var v = Object.defineProperty,
  f = Object.getOwnPropertySymbols,
  x = Object.prototype.hasOwnProperty,
  y = Object.prototype.propertyIsEnumerable,
  c = (a, r, e) => r in a ? v(a, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : a[r] = e,
  t = (a, r) => {
    for (var e in r || (r = {})) x.call(r, e) && c(a, e, r[e]);
    if (f) for (var e of f(r)) y.call(r, e) && c(a, e, r[e]);
    return a;
  };
const b = _ref => {
  let {
    alignItems: a,
    flex: r,
    flexDirection: e,
    justifyContent: l,
    flexWrap: o,
    gap: p,
    rowGap: n,
    columnGap: i
  } = _ref;
  return t(t(t(t(t(t(t(t({
    display: "flex"
  }, a && {
    alignItems: a
  }), r && {
    flex: r
  }), e && {
    flexDirection: e
  }), l && {
    justifyContent: l
  }), o && {
    flexWrap: o
  }), p && {
    gap: "var(".concat(p, ")")
  }), n && {
    rowGap: "var(".concat(n, ")")
  }), i && {
    columnGap: "var(".concat(i, ")")
  });
};
export { b as withFlex };